export default "__VITE_ASSET__irZOP0Y3__"